import { render, staticRenderFns } from "./UnsubmitList.vue?vue&type=template&id=77c9248c&"
import script from "./UnsubmitList.vue?vue&type=script&lang=ts&"
export * from "./UnsubmitList.vue?vue&type=script&lang=ts&"
import style0 from "./UnsubmitList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports